import React, { useState } from "react";
import { Button, Card, CardContent, CardActions } from "@material-ui/core";
import { useGetInvoiceQuery, useResyncInvoiceMutation } from "@graphql";
import { Spinner } from "@components";
import { InvoiceCard } from "../BookingInvoiceDialog/InvoiceCard";
import { useSnackbars } from "@hooks";
import { useInvoiceProvider } from "../useInvoiceProvider";
import { openInNewWindow } from "@utils/openInNewWindow";

type Props = {
  invoiceNumber: string;
  costCenterId: string;
  withDetails: boolean;
  withResync: boolean;
};

export function InvoicePopup(props: Props) {
  const [resyncing, setResyncing] = useState(false);
  const snack = useSnackbars();
  const invoiceProvider = useInvoiceProvider(props.costCenterId);

  const { data, loading, error } = useGetInvoiceQuery({
    variables: {
      number: props.invoiceNumber,
      provider: invoiceProvider
    },
    fetchPolicy: "cache-first"
  });

  const [resyncMutation] = useResyncInvoiceMutation({
    variables: {
      number: props.invoiceNumber,
      provider: invoiceProvider
    }
  });

  const handleResync = () => {
    setResyncing(true);
    resyncMutation()
      .then(() => snack.showSuccess("Klart"))
      .catch((e) => snack.showError(`cannot resync invoice<br>${e}`))
      .finally(() => setResyncing(false));
  };

  if (loading) {
    return (
      <div style={{ padding: 16 }}>
        <Spinner />
      </div>
    );
  }

  if (error) {
    return null;
  }

  return (
    <Card elevation={2}>
      <CardContent>
        <InvoiceCard data={data.invoiceByNumber} />
      </CardContent>

      <CardActions style={{ justifyContent: "flex-end" }}>
        {props.withResync && (
          <Button size="small" onClick={handleResync} disabled={resyncing}>
            Resync
          </Button>
        )}

        {props.withDetails && (
          <Button
            size="small"
            onClick={() => openInNewWindow(data.invoiceByNumber.PreviewUrl)}
            disabled={resyncing}
          >
            Se detaljer
          </Button>
        )}
      </CardActions>
    </Card>
  );
}
